export const BreakdownTypes = {
  Shipping: 'shipping',
  Tax: 'tax',
  Discount: 'discount',
} as const;

export interface PaymentBreakdown {
  /**
   * @deprecated This field is deprecated and will be removed in a future version.
   * The itemsTotal is now calculated automatically from orderItems.
   * Please remove this field from your paymentBreakdown object.
   */
  itemsTotal?: string;
  shipping?: string;
  tax?: string;
  discount?: string;
}

export type BreakdownTypesKeys = keyof typeof BreakdownTypes;
export type BreakdownTypesValues = (typeof BreakdownTypes)[BreakdownTypesKeys];
